<template>
  <div id="registration-form-add-or-update-dialog" class="custom-modal">
    <div class="modal-body">

      <input autocomplete="false" name="hidden" type="text" style="display:none;" />
  
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="form-group col-md-3">
              <label>{{this.$t('event.table.title')}}</label>
              <el-input
                v-model="form.title"
                :class="$inputError('title', validationErrors)"
              ></el-input>
              <span class="error">
                {{
                $errorMessage("title", validationErrors)
                }}
              </span>
            </div>

            <div class="form-group col-md-6">
              <label style="display: block">{{this.$t('justThesePacks')}}</label>

              <el-select
                :disabled="form.type == 1 || form.type == 2"
                v-model="form.packetIDs"
                placeholder="Paketler"
                multiple
              >
                <el-option
                  v-for="item in $store.state.packets.items"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                ></el-option>
              </el-select>
              <span class="error">
                {{
                $errorMessage("orderNO", validationErrors)
                }}
              </span>
            </div>

            <div class="form-group col-md-3">
              <label style="display: block">{{this.$t('event.table.sequence')}}</label>

              <el-input-number
                style="width: 100%;"
                :placeholder="$t('ex1')"
                v-model="form.orderNO"
                :min="1"
                :class="$inputError('orderNO', validationErrors)"
              ></el-input-number>
              <span class="error">
                {{
                $errorMessage("orderNO", validationErrors)
                }}
              </span>
            </div>

            <div class="form-group col-md-3">
              <label style="display: block">Tip</label>

              <el-select
                :disabled="form.id != null"
                v-model="form.type"
                :placeholder="$t('event.table.type')"
              >
                <el-option
                  v-for="item in $enums.inputTypes"
                  :key="item.value"
                  :label="item.title"
                  :value="item.value"
                ></el-option>
              </el-select>
              <span class="error">
                {{
                $errorMessage("type", validationErrors)
                }}
              </span>
            </div>

            <div class="form-group col-md-3">
              <label for style="display: block">{{this.$t('require')}}</label>
              <el-switch
                v-model="form.isRequired"
                :active-text="$t('event.variables.yes')"
                :inactive-text="$t('event.variables.no')"
              ></el-switch>
            </div>

            <div class="form-group col-md-3">
              <label for style="display: block">{{this.$t('includeSearch')}}</label>
              <el-switch
                v-model="form.showOnTable"
                :active-text="$t('event.variables.yes')"
                :inactive-text="$t('event.variables.no')"
              ></el-switch>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="form.type == 10 || form.type == 11">
        <div class="col-md-3">
          <label for>Minimum Uzunluk</label>
          <el-input-number :min="0" v-model="form.minLength"></el-input-number>
          <span class="error">
            {{
            $errorMessage("minLength", validationErrors)
            }}
          </span>
        </div>
        <div class="col-md-3">
          <label for>Maksimum Uzunluk</label>
          <el-input-number :min="0" v-model="form.maxLength"></el-input-number>
          <span class="error">
            {{
            $errorMessage("maxLength", validationErrors)
            }}
          </span>
        </div>
      </div>

      <div class="row" v-if="form.type == 14">
        <div class="col-md-3">
          <label for>Minimum Değer</label>
          <el-input-number :min="0" v-model="form.minValue"></el-input-number>
          <span class="error">
            {{
            $errorMessage("minValue", validationErrors)
            }}
          </span>
        </div>
        <div class="col-md-3">
          <label for>Maksimum Değer</label>
          <el-input-number :min="0" v-model="form.maxValue"></el-input-number>
          <span class="error">
            {{
            $errorMessage("maxValue", validationErrors)
            }}
          </span>
        </div>
      </div>

      <div class="row" v-if="form.type == 15 || form.type == 16">
        <div
          class="col-md-12"
          style="display: flex; flex-direction: row; align-items: center; justify-content: space-between"
        >
          <span>Seçenekler</span>
          <el-button size="mini" type="primary" @click="addOption">Yeni Seçenek Ekle</el-button>
        </div>
        <div
          style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; margin-top: 15px;"
          v-for="(item, index) in form.answers"
          :key="index"
          class="col-md-12"
        >
          <el-input
            placeholder="Seçeneğinizi Buraya Girin"
            v-model="form.answers[index]"
            style="margin-right: 10px;"
          ></el-input>
          <el-button type="danger" @click="deleteOption(index)">{{ $t('event.table.delete') }}</el-button>
        </div>
      </div>

    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog');">Kapat</el-button>
        <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
          <el-button slot="reference" type="danger" icon="fas fa-trash" v-if="form.id != null"> Sil</el-button>
        </el-popconfirm>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="save">Kaydet</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import axios from "axios";
import ItemInfo from "./ItemInfo";
export default {
  components: { ItemInfo, quillEditor },
  name: "QuestionLibraryAddOrUpdate",
  props: ["data"],
  data() {
    return {
      form: {
        id: null,
        title: null,
        orderNO: 1,
        isRequired: true,
        showOnTable: true,
        packetIDs: [],
        type: null,
        maxLength: null,
        minLength: null,
        minValue: null,
        maxValue: null,
        answers: []
      },
      axios,
      validationErrors: [],
      showInfo: false
    };
  },
  methods: {
    deleteOption(index) {
      this.form.answers.splice(index, 1);
    },
    addOption() {
      this.form.answers.push(null);
    },
    deleteItem() {
      var index = this.$store.state.registrationforms.items.findIndex(
        k => k.id == this.form.id
      );
      if (index != -1) {
        this.$emit("deleteMe", index);
        this.$emit("closeMe");
      }
    },
    save() {
      this.validationErrors = [];
      axios.post("registrationinput/addorupdate", this.form).then(res => {
        this.validationErrors = res.data.validationErrors;
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.$message.success(res.data.alert.message);
          if (this.form.id == null) {
            this.$emit("itemAdded");
            this.form = {
              id: null,
              title: null,
              orderNO: 1,
              isRequired: true,
              showOnTable: true,
              packetIDs: [],
              type: null,
              maxLength: null,
              minLength: null,
              minValue: null,
              maxValue: null,
              answers: []
            };
          } else {
            this.$emit("itemUpdated", JSON.parse(JSON.stringify(this.form)));
            if (this.showInfo) {
              this.showInfo = false;
              setTimeout(() => {
                this.showInfo = true;
              }, 350);
            }
          }
        }
      });
    }
  },
  watch: {
    data: function(newVal) {
      this.showInfo = false;
      if (newVal != undefined && newVal != null) {
        this.form = this.data;
        this.validationErrors = [];
      } else {
        this.form = {
          id: null,
          title: null,
          orderNO: 1,
          isRequired: true,
          showOnTable: true,
          packetIDs: [],
          type: null,
          maxLength: null,
          minLength: null,
          minValue: null,
          maxValue: null,
          answers: []
        };
      }
    },
    "form.type": function() {
      if (this.form.type == 1 || this.form.type == 2) {
        this.form.packetIDs = [];
      }
    }
  },
  created() {
    if (this.data != undefined && this.data != null) {
      this.form = this.data;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/RegistrationFormAddUpdate.vue